export const GET_SYSTEM_ADMIN_SELLING_GROUP = 'getSystemAdminSellingGroup';
export const UPDATE_SYSTEM_ADMIN_SELLING_GROUP = 'updateSystemAdminSellingGroup';
export const ADD_SYSTEM_ADMIN_SELLING_GROUPS = 'addSystemAdminSellingGroups';
export const ADD_SYSTEM_ADMIN_SELLING_GROUP = 'addSystemAdminSellingGroup';
export const DELETE_SYSTEM_ADMIN_SELLING_GROUP = 'deleteSystemAdminSellingGroup';
